// extracted by mini-css-extract-plugin
export default {"button":"sticky_burger_menu4_button__BNBDe","button2":"sticky_burger_menu4_button2__h0JdB","ligne":"sticky_burger_menu4_ligne__07M+G","logo":"sticky_burger_menu4_logo__UB7Hr"};